/**
 * Creates user marker to given location. Note! Requires Google Maps JS API.
 *
 * @param {google.maps.LatLngLiteral} coordinates Object containing lat/lng values.
 * @returns {UserMarker} Created UserMarker instance.
 */
function createUserMarker(coordinates) {
  function UserMarker(location) {
    this.setPosition(location);
  }

  UserMarker.prototype = new window.google.maps.OverlayView();
  UserMarker.prototype.getPosition = function() {
    return this.latlng;
  };
  UserMarker.prototype.setPosition = function(location) {
    const redraw = !!this.latlng;
    this.latlng = new window.google.maps.LatLng({ lat: location.lat, lng: location.lng });
    if (redraw) {
      this.draw();
    }
  };
  UserMarker.prototype.onAdd = function() {
    this.div = document.createElement('div');
    this.div.classList.add('marker-user-location');
    this.div.style.visibility = 'visible';

    const panes = this.getPanes();
    panes.markerLayer.appendChild(this.div);
  };
  UserMarker.prototype.draw = function() {
    const point = this.getProjection()?.fromLatLngToDivPixel(this.getPosition());
    if (point) {
      this.div.style.left = point.x + 'px';
      this.div.style.top = point.y + 'px';
    }
  };
  UserMarker.prototype.onRemove = function() {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      delete this.div;
    }
  };
  UserMarker.prototype.hide = function() {
    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };
  UserMarker.prototype.show = function() {
    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };
  UserMarker.prototype.isVisible = function() {
    return this.div.style.visibility === 'visible';
  };

  return new UserMarker(coordinates);
}

export {
  createUserMarker
};
